<!-- 科一专项 -->
<template>
    <div class="posre">
                <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>

        <div class="w100p">
            <div class="w1200 mauto pt50 pb50 overflow">
                <div class=" disinblock w68p floatl">

                    <p class="fs30 c333">2020年小车科目一专项试题</p>
                    <div class="fs26 c333 mt20">
                        <p class="cursor alit mt25 mb25 borther answerParent ">
                            {{practice.exercise_id}}、
                            {{practice.title}}
                        </p>
                        <div class="fs26 c333 mt20">
                            <p :class="{'aaaaa':once==1}" v-for="(item,index) in choose_listX" :key="index"
                                @click="choose(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther answerParent" ref="answerParent">
                                <!-- <img class="w30 h30 answerImg" :src="answerImg" alt="" ref="answerImg"> -->

                                <img v-if="item.T==0" class="w30 h30" src="../../public/img/img68.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==1" class="w30 h30" src="../../public/img/img67.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==2" class="w30 h30" src="../../public/img/img69.png" alt=""
                                    ref="answerImg">
                                <span class="disinblock ml16"> {{item.chose}} </span>
                            </p>
                            <div class="fs16" v-show="noteShow==1">{{practice.note}}</div>
                        </div>
                        <div v-show="practice.image" class="pl16 pr16 pt20 pb20">
                            <img class="w300 hauto bradius8 " :src="practice.image " alt="">
                        </div>
                        <div class="pt8 pb8 w100p overhidden">
                            <p class="overhidden  mauto">
                                <span @click="last()"
                                    class="border2e bradius25 fs20 cfff  bg1f8  floatl mr20 pl30 pr30 pt12 pb12 cursor">上一题</span>
                                <span @click="next()"
                                    class="border2e bradius25 fs20 disinblock floatl ml20 pl30 pr30 pt12 pb12 cfff bg1f8 cursor">下一题</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                schoolList2: [],
                index: 0,
                practice: { //练习题
                    title: '',
                    note: '',
                    answer: '', //正确答案
                    image: '',
                    title: '',
                    exercise_id: '', //题号
                },
                choose_listX: [], //选项
                practiceList: [],
                chooseList: [],
                typeIndex: 0,
                answerImg: require('../../public/img/img68.png'),
                once: 0,
                Already: [],
                chapterX: '',
                orderX: '',
                noteShow: 0
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            getPractice() {
                let that = this;

                that.orderX = that.chapterX;


                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                        "exercise_chapter": that.orderX
                    },
                    success: function(data) {
                        let typeIndex = that.typeIndex;
                        that.practice = data.obj[typeIndex];
                        that.practiceList = data.obj;
                        that.practice.image = data.obj[typeIndex].image;
                        that.practice.answer = data.obj[typeIndex].answer;
                        that.practice.note = data.obj[typeIndex].note;
                        let arr2 = data.obj[typeIndex].choose_list.split("|");
                        for (let i = 0; i < arr2.length; i++) {
                            let P = {
                                chose: arr2[i],
                                T: 0
                            }
                            that.choose_listX.push(P);
                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            next() {
                let that = this;
                if (that.practiceList.length != that.typeIndex + 1) {
                    that.typeIndex++;
                    that.Judgment();
                } else {
                    alert('这已经是最后一题了')
                }

            },
            last() {
                let that = this;
                if (that.typeIndex == 0) {
                    alert('这已经是第一题了')
                } else {
                    that.typeIndex--;
                    that.Judgment();
                }
            },
            Judgment() {

                let that = this;
                //let aa = that.$refs.answerImg;
                that.noteShow = 0;
                this.practice = this.practiceList[this.typeIndex];
                let getAlready = [];
                if (that.chapterX == 1) {
                    getAlready = that.$store.state.chapterList1;
                }
                if (that.chapterX == 2) {
                    getAlready = that.$store.state.chapterList2;
                }
                if (that.chapterX == 3) {
                    getAlready = that.$store.state.chapterList3;
                }
                if (that.chapterX == 4) {
                    getAlready = that.$store.state.chapterList4;
                }
                let arr2 = that.practice.choose_list.split("|");

                that.choose_listX = []
                that.markList = []
                let markX = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1,

                };
                for (let i = 0; i < arr2.length; i++) {
                    let P = {
                        chose: arr2[i],
                        T: 0
                    }
                    that.choose_listX.push(P)
                    that.markList.push(markX)
                }
                for (let i = 0; i < getAlready.length; i++) {
                    if (getAlready[i].index == that.practice.exercise_id) { //getAlready[i].index做了的题
                        if (getAlready[i].rigthFalse == true) {
                            that.once = 1;
                            that.noteShow = 1;
                            console.log('对');
                            //item我选的那道题选项
                            //index1我选的那道题下标
                            console.log(that.choose_listX)

                            let P = {
                                chose: that.choose_listX[getAlready[i].index1].chose,
                                T: 1
                            }
                            that.choose_listX.splice(getAlready[i].index1, 1, P)
                        } else {
                            let j = getAlready[i].index1;
                            console.log('错误');
                            that.noteShow = 1;
                            //循环选项
                            let itemX = that.practice.choose_list;

                            let P = {
                                chose: that.choose_listX[j].chose,
                                T: 2
                            }
                            that.choose_listX.splice(j, 1, P)
                            console.log('232322222222');
                            console.log(itemX);
                            for (let jj = 0; jj < arr2.length; jj++) {
                                // console.log(getAlready[i]);
                                if (arr2[jj].indexOf(getAlready[i].answer) != -1) {
                                    let P = {
                                        chose: that.choose_listX[jj].chose,
                                        T: 1
                                    }
                                    that.choose_listX.splice(jj, 1, P)
                                        //that.$refs.answerImg[jj].src = require('../../public/img/img67.png');
                                }
                            }
                            console.log('3333333333');
                            that.T = 2;
                            //that.$refs.answerImg[j].src = require('../../public/img/img69.png');
                        }
                        that.once = 1;
                        return;
                    } else {
                        that.once = 0;
                    }
                }
                if (that.once == 0) {
                    let mark1 = {
                        item: '',
                        index: '',
                        index1: '',
                        rigthFalse: '',
                        answer: ''
                    };
                    if (that.typeIndex == getAlready.length) {
                        // that.Already.splice(index - 1, 1, mark)
                        that.Already.push(mark1)
                    }
                    that.$forceUpdate()
                    if (that.chapterX == 1) {
                        that.$store.dispatch('Chapter1').then(() => {
                            that.$store.state.chapterList1 = that.Already;
                        });
                    }
                    if (that.chapterX == 2) {
                        that.$store.dispatch('Chapter2').then(() => {
                            that.$store.state.chapterList2 = that.Already;
                        });
                    }
                    if (that.chapterX == 3) {
                        that.$store.dispatch('Chapter3').then(() => {
                            that.$store.state.chapterList3 = that.Already;
                        });
                    }
                    if (that.chapterX == 4) {
                        that.$store.dispatch('Chapter4').then(() => {
                            that.$store.state.chapterList4 = that.Already;
                        });
                    }
                }
            },

            choose(item, answer, e, index, practice, index1) {

                let that = this;
                let rigth = '';
                that.once = 1;
                that.noteShow = 1;
                if (item.indexOf(answer) != -1) {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 1
                    }
                    that.choose_listX.splice(index1, 1, P)
                        //e.currentTarget.firstElementChild.src = require('../../public/img/img67.png');
                    rigth = true;
                } else {
                    //e.currentTarget.firstElementChild.src = require('../../public/img/img69.png');
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 2
                    }
                    that.choose_listX.splice(index1, 1, P)
                    for (let i = 0; i < that.choose_listX.length; i++) {
                        if (that.choose_listX[i].chose.indexOf(answer) != -1) {
                            let P = {
                                chose: that.choose_listX[i].chose,
                                T: 1
                            }
                            that.choose_listX.splice(i, 1, P)
                        }
                    }
                    rigth = false;
                }
                let mark = {
                    item: item,
                    index: index,
                    index1: index1,
                    rigthFalse: rigth,
                    answer: answer,
                };

                let getAlready = [];

                if (that.chapterX == 1) {
                    getAlready = that.$store.state.chapterList1; //取vuex缓存'
                }
                if (that.chapterX == 2) {
                    getAlready = that.$store.state.chapterList2; //取vuex缓存'
                }
                if (that.chapterX == 3) {
                    getAlready = that.$store.state.chapterList3; //取vuex缓存'
                }
                if (that.chapterX == 4) {
                    getAlready = that.$store.state.chapterList4; //取vuex缓存'
                }
                console.log(getAlready)
                if (getAlready.length == 0) {
                    that.Already.push(mark)
                } else {
                    that.Already.splice(index - 1, 1, mark)
                }
                that.$forceUpdate()

                if (that.chapterX == 1) {
                    that.$store.dispatch('Chapter1').then(() => {
                        that.$store.state.chapterList1 = that.Already;
                    });
                }
                if (that.chapterX == 2) {
                    that.$store.dispatch('Chapter2').then(() => {
                        that.$store.state.chapterList2 = that.Already;
                    });
                }
                if (that.chapterX == 3) {
                    that.$store.dispatch('Chapter3').then(() => {
                        that.$store.state.chapterList3 = that.Already;
                    });
                }
                if (that.chapterX == 4) {
                    that.$store.dispatch('Chapter4').then(() => {
                        that.$store.state.chapterList4 = that.Already;
                    });
                }
            },
            tiku() {
                this.chapterX = this.$route.query.chapter;
            }
        },


        created() {
            this.tiku();
            this.getPractice();
            this.Judgment();
            this.cityName = this.$store.state.cityName;
        },
        mounted() {
            let that = this;
            if (window.performance.navigation.type == 1) {
                console.log("页面被刷新")
                that.$forceUpdate()
                if (that.chapterX == 1) {
                    that.Already = that.$store.state.chapterList1;
                    that.$store.dispatch('Chapter1').then(() => {
                        that.$store.state.chapterList1 = that.Already;
                    });
                }
                if (that.chapterX == 2) {
                    that.Already = that.$store.state.chapterList2;
                    that.$store.dispatch('Chapter2').then(() => {
                        that.$store.state.chapterList2 = that.Already;
                    });
                }
                if (that.chapterX == 3) {
                    that.Already = that.$store.state.chapterList3;
                    that.$store.dispatch('Chapter3').then(() => {
                        that.$store.state.chapterList3 = that.Already;
                    });
                }
                if (that.chapterX == 4) {
                    that.Already = that.$store.state.chapterList3;
                    that.$store.dispatch('Chapter4').then(() => {
                        that.$store.state.chapterList4 = that.Already;
                    });
                }
            }


        }
    }
</script>
<style scoped>
    .aaaaa {
        pointer-events: none;
    }
</style>